
































































import { Component, Emit, Model, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import countryRegionData from "country-region-data";
import * as rules from '@/rules';
//@ts-ignore
import { loadStripe, StripeCardElement } from '@stripe/stripe-js';
//@ts-ignore
let stripe: loadStripe.Stripe;


@Component({components: {}})
export default class PaymentInformation extends Vue {

    private readonly cardStyle = {
        'fontSize': '16px',
        'color': 'rgba(0, 0, 0, 0.87)',
        'margin-top': '10px'
    };

    @Ref('form')
    formRef!: HTMLFormElement;

    @Ref('card')
    cardRef!: any;

    @Prop()
    address!: any;
    private rules = rules;

    private isNonCardFormValid = false;

    private countryData = countryRegionData;
    private elements: any;
    private card: StripeCardElement;
    private isCardComplete = false;

    private form: any = {};

    @Model('change')
    private information: any;

    // private publishableKey = process.env.PUBLISHABLE_KEY;

    async mounted() {
        stripe = await loadStripe(process.env.VUE_APP_STRIPE_P_KEY || '');
        this.elements = stripe.elements({
            fonts: [{
                cssSrc: 'https://fonts.googleapis.com/css?family=Nunito'
            }]
        });

        this.card = this.elements.create('card', {
            classes: {base: 'card-element'},
            style: {
                base: this.cardStyle
            }
        })
        this.card.mount(this.cardRef);
        this.card.on('change', (event) => {
            this.isCardComplete = event.complete
            this.updateData();
        })
    }

    @Watch('isNonCardFormValid')
    private validityChanged() {
        this.updateData();
    }

    @Emit('change')
    private updateData() {
        return {
            address: this.form.address,
            first: this.form.first,
            last: this.form.last,
            card: this.card,
            country: this.form.country,
            state: this.form.state,
            valid: this.isNonCardFormValid && this.isCardComplete
        }
    }


}
